import "./Header.css";
import logo from "../../components/images/logo.png";
import mobileLogo from "../../components/images/mobilelogo.png";
import userIcon from "../../components/images/user.png";
import aiIcon from "../../components/images/ai.png";
import worldCup from "../../pages/home/HomeImage/worldcup.png";
import whiteLogo from "../../components/images/white-logo.png";
import darkmd from "../../components/images/darkmode.png";
import { Link, NavLink } from "react-router-dom";
import { useState, useRef, useEffect, use } from "react";
import search from "./Search.png";
import { useNavigate } from "react-router-dom";

const Header = ({
  dark,
  user,
  setDark,
  darktoggle,
  darkTog,
  openMenu,
  checkMenu,
  closeMenue,
  setOpenMenu,
  searchValue,
  setSearchValue,
}) => {
  const navigate = useNavigate();

  const [value, setValue] = useState("");
  const [closing, setClosing] = useState(false);

  const [showAI, setShowAI] = useState(false);
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");

  const [openSearch, setOpenSearch] = useState(false);

  const aiRef = useRef(null);
  const menuRef = useRef(null);

  const inputRef = useRef(null);

  useEffect(() => {
    if (openSearch) {
      inputRef.current?.focus();
    }
  }, [openSearch]);
  const suggestions = [
    "Latest football news",
    "Top scorers this season",
    "What team have won the most champions league",
    "Best teams right now",
  ];

  const handleSend = (msg) => {
    if (!msg.trim()) return;

    const userMsg = { sender: "user", text: msg };
    const botMsg = {
      sender: "bot",
      text: "AI response coming soon...",
    };

    setMessages((prev) => [...prev, userMsg, botMsg]);
    setInput("");
  };

  const handleClose = () => {
    setClosing(true);

    setTimeout(() => {
      setOpenMenu(false);
      setClosing(false);
    }, 500);
  };

  const handleNavClick = () => {
    setOpenMenu(false);
    setClosing(false);
  };

  //   useEffect(() => {
  //   const handleOutsideClick = (event) => {
  //     if (
  //       showAI &&
  //       aiRef.current &&
  //       !aiRef.current.contains(event.target)
  //     ) {
  //       setShowAI(false);
  //     }
  //   };

  //   document.addEventListener("mousedown", handleOutsideClick);

  //   return () => {
  //     document.removeEventListener(
  //       "mousedown",
  //       handleOutsideClick
  //     );
  //   };
  // }, [showAI]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (openSearch && !e.target.closest(".search-container")) {
        setOpenSearch(false);
      }

      if (showAI && aiRef.current && !aiRef.current.contains(e.target)) {
        setShowAI(false);
      }

      if (
        (openMenu || closing) &&
        menuRef.current &&
        !menuRef.current.contains(e.target)
      ) {
        handleClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showAI, openMenu, closing, openSearch]);

  return (
    <div
      className="HeaderWrapper"
      style={dark ? { backgroundColor: "#000" } : {}}>
      <NavLink className="logodiv desktop" to="./">
        <img src={mobileLogo} alt="" style={{ scale: "1.4" }} />
        <h1 style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
          FadaSports
        </h1>
      </NavLink>
      <div className="links desktop">
        <ul>
          <NavLink to="/competition/world-cup/1" onClick={handleClose}>
            <span
              style={{
                display: "flex",
                gap: "8px",
                flexDirection: "row-reverse",
              }}>
              <img src={worldCup} alt="" width="25px" />
              <h1
                style={{ scale: "1.2", color: dark ? "#fafafaff" : "" }}
                className="linkitem">
                World Cup
              </h1>
            </span>
          </NavLink>
          <NavLink
            className="linkitem"
            to="./livescore"
            style={dark ? { color: "#b4b4b4ff" } : {}}>
            Livescore
          </NavLink>
          <NavLink
            className="linkitem"
            to="./competition"
            style={dark ? { color: "#b4b4b4ff" } : {}}>
            Competition
          </NavLink>
          <NavLink
            className="linkitem"
            to="teams"
            style={dark ? { color: "#b4b4b4ff" } : {}}>
            Teams
          </NavLink>
          <NavLink
            className="linkitem"
            to="latest-news"
            style={dark ? { color: "#b4b4b4ff" } : {}}>
            Latest News
          </NavLink>
          {/* <NavLink
            className="linkitem"
            to="polls"
            style={dark ? { color: "#b4b4b4ff" } : {}}>
            Polls
          </NavLink>
          <NavLink
            className="linkitem"
            to="quizzes"
            style={dark ? { color: "#b4b4b4ff" } : {}}>
            Quiz
          </NavLink> */}
          {/* <NavLink className="linkitem" to="videos"
                style={dark ? {color: "#b4b4b4ff"} : {}}>Videos</NavLink> */}
          <NavLink
            className="linkitem"
            to="authors"
            style={dark ? { color: "#b4b4b4ff" } : {}}>
            Authors
          </NavLink>
        </ul>
        <nav>
          <div
            style={dark ? {} : { backgroundColor: "whitesmoke", zIndex: "100" }}
            className={`search-container ${dark ? "dark" : "light"} 
                // (${openSearch ? "active" : ""})
                `}>
            <input
              ref={inputRef}
              type="text"
              placeholder="Search..."
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
              onFocus={() => navigate(`/search?q=${searchValue || ""}`)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  navigate(`/search?q=${searchValue}`);
                }
              }}
              className="search-input"
            />
            <div
              className="search-icon"
              onClick={() => {
                setOpenSearch(true);
                navigate(`/search?q=${searchValue || ""}`);
              }}>
              <img
                src={search}
                alt=""
                className="ser"
                style={{ filter: "invert(1)", opacity: "0.8" }}
              />
            </div>
          </div>
          <Link to="/ai">
            <div
              onClick={() => setShowAI((prev) => !prev)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0px",
              }}>
              <img
                src={aiIcon}
                alt=""
                className="use ai-trigger"
                onClick={() => setShowAI((prev) => !prev)}
              />
              <p
                style={
                  dark
                    ? { color: "#fafafaff" }
                    : { color: "#3e3f3f", marginLeft: "-10px" }
                }>
                Ai
              </p>
            </div>
          </Link>

          <NavLink
            to="/profile"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "7px",
              color: dark ? "#fff" : "#111",
              textDecoration: "none",
              fontSize: "14px",
              fontWeight: "600",
            }}>
            {!user && (
              <img
                src={userIcon}
                alt=""
                className="use"
                style={dark ? { filter: "invert(1)" } : {}}
              />
            )}

            {user?.name && (
              <div
                className="profile-ban"
                style={{
                  padding: "7px 9px",
                  borderRadius: "50%",
                  color: "whitesmoke",
                  fontWeight: "900",
                  fontSize: "15px",
                }}>
                {user?.name
                  ? user.name
                      .split(" ")
                      .map((item) => item[0])
                      .join("")
                      .slice(0, 2)
                      .toUpperCase()
                  : "U"}
              </div>
            )}
          </NavLink>
        </nav>
      </div>

      <div className="mobile">
        <NavLink className="linkitem mobilelogo" to="./">
          <img src={mobileLogo} alt="" style={{ scale: "1.4" }} />
          <h1 style={dark ? { color: "#fafafaff" } : { color: "#161819" }}>
            FadaSports
          </h1>
        </NavLink>

        <span>
          <NavLink
            className="linkitem"
            to="./livescore"
            style={dark ? { color: "#fafafaff" } : {}}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0px",
                marginLeft: "60px",
                zIndex: "100",
                color: "rgba(165, 1, 1, 1)",
              }}>
              <span>
                <p></p>
              </span>
              LIVE
            </div>
          </NavLink>

          <Link to="/ai">
            <div
              onClick={() => setShowAI((prev) => !prev)}
              id="asked"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0px",
                maxWidth: "fit-content",
                marginRight: "6px",
              }}>
              <img src={aiIcon} alt="" className="use ai-trigger" />
              <p
                style={
                  dark
                    ? { color: "#fafafaff" }
                    : { color: "#3e3f3f", marginLeft: "-4px" }
                }>
                AI
              </p>
            </div>
          </Link>

          <NavLink
            to="/profile"
            style={{
              display: "flex",
              alignItems: "center",
              gap: "7px",
              color: dark ? "#fff" : "#111",
              textDecoration: "none",
              fontSize: "14px",
              fontWeight: "600",
            }}>
            {!user && (
              <img
                src={userIcon}
                alt=""
                className="use"
                style={dark ? { filter: "invert(1)" } : {}}
              />
            )}

            {user?.name && (
              <div
                className="profile-ban"
                style={{
                  borderRadius: "50%",
                  color: "whitesmoke",
                  fontWeight: "900",
                  fontSize: "16px",
                  scale: "0.72",
                }}>
                {user?.name
                  ? user.name
                      .split(" ")
                      .map((item) => item[0])
                      .join("")
                      .slice(0, 2)
                      .toUpperCase()
                  : "U"}
              </div>
            )}
          </NavLink>

          <img
            src={search}
            alt=""
            style={{
              filter: dark ? "" : "invert(1)",
              opacity: "0.8",
              marginTop: "4px",
              marginLeft: "4px",
              scale: "0.9",
            }}
            onClick={() => {
              setOpenSearch(true);
              navigate(`/search?q=${searchValue || ""}`);
            }}
          />
        </span>

        {/* {showAI && (
                <nav ref={aiRef} className="myai" style={dark ? {backgroundColor: "#272727ff"} : {}}>
                    <div className={`ai-chat`}
                     style={dark ? {backgroundColor: "#18181886"} : {}}
                    >
                        
                        <div className="ai-header">
                        <h3 style={dark ? {color: "#fafafaff"} : {}}>Ask fadaspot {
                            dark ? (<img src={whiteLogo} alt="" style={{scale: "0.65 0.84"}}/>) : (<img src={logo} alt="" style={{scale: "1.4"}}/>)
                            }</h3>
                        <span onClick={() => setShowAI(false)}  style={dark ? {color: "#fafafaff"} : {}}>✕</span>
                        </div>

                        <div className="ai-messages">
                        {messages.length === 0 && (
                            <div className="suggestions">
                            {suggestions.map((s, i) => (
                                <p key={i} onClick={() => handleSend(s)}
                                 style={dark ? {color: "#161819"} : {}}>
                                {s}
                                </p>
                            ))}
                            </div>
                        )}

                        {messages.map((msg, i) => (
                            <div key={i} className={`msg ${msg.sender}`}>
                            {msg.text}
                            </div>
                        ))}
                        </div>

                        <div className="ai-input">
                        <textarea
                        style={{backgroundColor: "transparent", color: dark ? "#fafafaff" : ""}}
                            type="text"
                            placeholder="Ask us a question..."
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                        />
                            <img src={aiIcon} alt="" 
                                        onClick={() => {
                                            handleSend(input);
                                        }}/>
                        </div>
                    </div>
              </nav>
            )} */}

        {(openMenu || closing) && (
          <section
            ref={menuRef}
            className={`menu ${closing ? "close" : "open"}`}
            style={dark ? { backgroundColor: "#1d1d1dff" } : {}}>
            <div className="top">
              <Link to="./" onClick={handleClose}>
                <span>
                  <img
                    src={dark ? whiteLogo : logo}
                    alt=""
                    style={{ scale: dark ? "1" : "2.3 2" }}
                  />
                  <h1>Fada sports</h1>
                </span>
              </Link>

              <div
                className={`search-container ${dark ? "dark" : "light"} ${openSearch ? "active" : ""}`}>
                <div
                  className="search-icon"
                  onClick={() => {
                    setOpenSearch(true);
                    handleClose();
                    navigate(`/search?q=${searchValue || ""}`);
                  }}>
                  <img src={search} alt="" className="ser" />
                </div>
              </div>
            </div>
            <div
              className="categories"
              style={dark ? { backgroundColor: "#040438ff" } : {}}>
              <span
                style={{
                  display: "flex",
                  flexDirection: "row-reverse",
                  justifyContent: "space-between",
                }}>
                <h1>Categories</h1>
                <Link to="/competition/world-cup/1" onClick={handleClose}>
                  <span
                    style={{
                      display: "flex",
                      gap: "10px",
                      flexDirection: "row-reverse",
                    }}>
                    <img src={worldCup} alt="" width="25px" />
                    <h1 style={{ scale: "1.1" }}>World Cup</h1>
                  </span>
                </Link>
              </span>
              <nav>
                <span>
                  <NavLink
                    className="linkitem"
                    to="./livescore"
                    onClick={handleClose}>
                    Livescores
                  </NavLink>
                  <NavLink
                    className="linkitem"
                    to="./polls"
                    onClick={handleClose}>
                    Polls
                  </NavLink>
                </span>
                <span>
                  <NavLink
                    className="linkitem"
                    to="./competition"
                    onClick={handleClose}>
                    Competition
                  </NavLink>
                  <NavLink
                    className="linkitem"
                    to="quizzes"
                    onClick={handleClose}>
                    Quiz
                  </NavLink>
                </span>
                <span>
                  <NavLink
                    className="linkitem"
                    to="teams"
                    onClick={handleClose}>
                    Teams
                  </NavLink>
                  <NavLink
                    className="linkitem"
                    to="latest-news"
                    onClick={handleClose}>
                    Latest News
                  </NavLink>
                </span>
                <span style={{ alignItems: "center", marginTop: "-10px" }}>
                  <NavLink
                    className="linkitem"
                    to="authors"
                    onClick={handleClose}>
                    Authors
                  </NavLink>
                  <nav className="darkmode" onClick={darktoggle}>
                    <div className="darkmode-left">
                      <div className={`theme-icon ${darkTog ? "active" : ""}`}>
                        <img
                          src={darkmd}
                          alt=""
                          style={{ filter: !dark ? "invert(1)" : "invert(0)" }}
                        />
                      </div>

                      <div className="theme-text">
                        <strong>{!dark ? "Dark Mode" : "Light Mode"}</strong>
                      </div>
                    </div>
                  </nav>
                </span>
              </nav>
            </div>
            <div className="cancel">
              <p onClick={handleClose}>X</p>
            </div>
          </section>
        )}
      </div>
    </div>
  );
};

export default Header;
